import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Table, Space, Image } from 'antd'
import ActionBtn from '@/components/TableWidgets/ActionBtn'
import useListFetch from '@/components/ListHooks'

import EncryptionPhone from '@/components/EncryptionPhone'
import { DOCKING_PEOPLE } from '@/components/PhoneType'

import UserInfoModal from '../UserInfoModal'
import { stateTransToLabel, jobsTransToLabel } from '../../helper'
import styles from './index.less'

const table = forwardRef(({ rowKey = 'id', dispatch, fetch, ...restProps }, ref) => {
    const { dataSource, loading, pagination, reload, refresh } = useListFetch(fetch)

    const [infoCtrl, setInfoCtrl] = useState({
        visible: false,
        data: null
    })

    useImperativeHandle(ref, () => ({
        refresh,
        reload,
        create: () =>
            setInfoCtrl({
                formType: 'create',
                visible: true,
                data: null
            })
    }))

    const columns = [
        {
            title: '编号',
            dataIndex: 'userCode',
            align: 'center',
            width: '130px'
        },
        {
            title: '姓名',
            dataIndex: 'fullName',
            align: 'center',
            width: '130px'
        },
        {
            title: '手机号',
            dataIndex: 'phone',
            align: 'center',
            width: '130px',
            render(_, record) {
                const { id } = record
                return <EncryptionPhone id={id} type={DOCKING_PEOPLE} phone={_} />
            }
        },
        {
            title: '岗位',
            dataIndex: 'remark',
            align: 'center',
            width: '200px',
            render(_, record) {
                return jobsTransToLabel(_)
            }
        },
        {
            title: '头像',
            dataIndex: 'headPicture',
            align: 'center',
            width: '60px',
            render: _ => {
                return _ ? <Image src={_} width={40} height={40} /> : null
            }
        },
        {
            title: 'QQ',
            dataIndex: 'qqNum',
            align: 'center',
            width: '200px'
        },
        {
            title: '微信',
            dataIndex: 'weixinNum',
            align: 'center',
            width: '200px'
        },
        {
            title: '企微二维码',
            dataIndex: 'qrCode',
            align: 'center',
            width: '60px',
            render: _ => {
                return _ ? <Image src={_} width={40} height={40} /> : null
            }
        },
        {
            title: '启用',
            dataIndex: 'disabled',
            align: 'center',
            width: '200px',
            render(_, record) {
                return stateTransToLabel(_)
            }
        },
        {
            title: '创建人',
            dataIndex: 'createby',
            align: 'center',
            width: '200px'
        },
        {
            title: '创建时间',
            dataIndex: 'created',
            align: 'center',
            width: '200px'
        },
        {
            title: '修改人',
            dataIndex: 'updateby',
            align: 'center',
            width: '200px'
        },
        {
            title: '修改时间',
            dataIndex: 'updated',
            align: 'center',
            width: '200px'
        },
        {
            title: '操作',
            align: 'center',
            width: '80px',
            fixed: 'right',
            render(_, record) {
                return (
                    <Space direction="vertical">
                        <ActionBtn
                            onClick={() =>
                                setInfoCtrl({
                                    formType: 'edit',
                                    visible: true,
                                    data: record
                                })
                            }>
                            修改
                        </ActionBtn>
                    </Space>
                )
            }
        }
    ]

    const infoModalProps = {
        ...infoCtrl,
        visible: infoCtrl.visible,
        dataSource: infoCtrl.data,
        onOk() {
            setInfoCtrl(prev => ({
                ...prev,
                visible: false
            }))

            dispatch({
                type: 'admin/queryDockingList'
            })

            reload()
        },
        onCancel() {
            setInfoCtrl(prev => ({
                ...prev,
                visible: false
            }))
        }
    }

    const scrollHeight = window.innerHeight - 300

    return (
        <>
            <Table
                className={styles.container}
                rowKey={rowKey}
                bordered
                size="small"
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                scroll={{
                    x: 'max-content',
                    y: scrollHeight,
                    scrollToFirstRowOnChange: true
                }}
                pagination={pagination}
                {...restProps}
            />

            <UserInfoModal {...infoModalProps} />
        </>
    )
})

export default table
